import { buildModelManager } from "../builder.js";
const DefaultStripeNumberOfOptinsHistoricSelection = {
  __typename: true,
  id: true,
  computedAt: true,
  createdAt: true,
  customerId: true,
  delta: true,
  exported: true,
  updatedAt: true,
  value: true
};
const modelApiIdentifier = "stripeNumberOfOptinsHistoric";
const pluralModelApiIdentifier = "stripeNumberOfOptinsHistorics";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByComputedAt",
    findByField: "computedAt",
    findByVariableName: "computedAt",
    modelApiIdentifier,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByComputedAt",
    findByField: "computedAt",
    findByVariableName: "computedAt",
    modelApiIdentifier,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByCustomer",
    findByField: "customerId",
    findByVariableName: "customerId",
    modelApiIdentifier,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByCustomer",
    findByField: "customerId",
    findByVariableName: "customerId",
    modelApiIdentifier,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createStripeNumberOfOptinsHistoric",
    operationReturnType: "CreateStripeNumberOfOptinsHistoric",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      stripeNumberOfOptinsHistoric: {
        required: false,
        type: "CreateStripeNumberOfOptinsHistoricInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection
  },
  {
    type: "action",
    operationName: "bulkCreateStripeNumberOfOptinsHistorics",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateStripeNumberOfOptinsHistoricsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection
  },
  {
    type: "action",
    operationName: "updateStripeNumberOfOptinsHistoric",
    operationReturnType: "UpdateStripeNumberOfOptinsHistoric",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      stripeNumberOfOptinsHistoric: {
        required: false,
        type: "UpdateStripeNumberOfOptinsHistoricInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateStripeNumberOfOptinsHistorics",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateStripeNumberOfOptinsHistoricsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection
  },
  {
    type: "action",
    operationName: "deleteStripeNumberOfOptinsHistoric",
    operationReturnType: "DeleteStripeNumberOfOptinsHistoric",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteStripeNumberOfOptinsHistorics",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertStripeNumberOfOptinsHistoric",
    operationReturnType: "UpsertStripeNumberOfOptinsHistoric",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      stripeNumberOfOptinsHistoric: {
        required: false,
        type: "UpsertStripeNumberOfOptinsHistoricInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateStripeNumberOfOptinsHistoricResult": { hasReturnType: false },
      "... on UpdateStripeNumberOfOptinsHistoricResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertStripeNumberOfOptinsHistorics",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertStripeNumberOfOptinsHistoricsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultStripeNumberOfOptinsHistoricSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "stripeNumberOfOptinsHistoricGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const StripeNumberOfOptinsHistoricManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultStripeNumberOfOptinsHistoricSelection,
  operations
);
export {
  DefaultStripeNumberOfOptinsHistoricSelection,
  StripeNumberOfOptinsHistoricManager
};
//# sourceMappingURL=StripeNumberOfOptinsHistoric.js.map
